// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, enumOf, objectOf, maybe, recordOf } from "@altostra/type-validations";
import { boolean, maybeBoolean, number, string } from "@altostra/type-validations/lib/primitives";

import type { ExperimentBehavior } from "./types";

const isAbTestResult = objectOf({
  received: number,
  converted: number,
  winner: maybe(number),
  pvalue: number,
  send_percentage: number,
});

const isExperimentBehavior = enumOf<ExperimentBehavior>("click", "conversion", "open");

const isFeature = objectOf({ variant_id: string, feature: string });
const isTopEvent = objectOf({ name: string, impact: number });

const isSuperOptimizerResult = objectOf({
  completed: boolean,
  finished_at: number,
  projected_lift: number,
  custom_events_used: boolean,
  feature_winners: recordOf({ key: string, value: arrayOf(isFeature) }),
  top_features: recordOf({ key: string, value: arrayOf(isTopEvent) }),
  used_at: maybe(number),
});

export const isEngagementCampaignsExperimentDataCampaignIdResult = objectOf({
  automatic_distribution_optimization: maybeBoolean,
  send_percentage_optimization_complete: maybeBoolean,
  intelligent_selection_fixed_holdout_rollout: maybeBoolean,
  intelligent_selection_stopping_mode: maybe(string),
  automatic_variant_selection: maybe(string),
  ab_test: maybe(
    objectOf({
      is_scheduled: boolean,
      completed: boolean,
      has_winner: boolean,
      in_progress: boolean,
      is_significant: boolean,
      ab_test_results: recordOf({ key: string, value: isAbTestResult }),
      completed_test_start_time: number,
      completed_test_end_time: number,
      holdout_percent: number,
      super_optimizer_enabled: boolean,
      post_test_send_time: number,
      post_test_send_window_hours: maybe(number),
      ab_testing_conversion: isExperimentBehavior,
      daily_stat_conversion_field: string,
      enabled: boolean,
      must_be_significant: boolean,
      holdout_percent_saved: number,
    })
  ),
  super_optimizer_result: maybe(isSuperOptimizerResult),
  super_optimizer_result_lift: maybe(isSuperOptimizerResult),
});
